import { BaseStore } from 'fluxible/addons';

class BriefStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.briefData = {};
    }

    load(payload) {
        this.briefData = payload.body

        if (payload.language_options) {
            this.languageOptions = payload.language_options;
        }

        if (payload.industry_options) {
            this.industryOptions = payload.industry_options;
        }

        if (payload.allow_stock_images_options) {
            this.allowStockImagesOptions = payload.allow_stock_images_options;
        }

        this.emitChange();
    }

    updateFieldValue(payload) {
        this.briefData[payload.field] = payload.value;
        this.emitChange();
    }
}

BriefStore.storeName = 'BriefStore';
BriefStore.handlers = {
    LOAD_DRAFT_DATA: 'load',
    SAVE_DRAFT_SUCCESS: 'load',
    UPDATE_FIELD_VALUE: 'updateFieldValue'
};

export default BriefStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefStore.js